<template>
<section class="contact-section bg-gray-100 px-5">
   <div class="container mx-auto text-center py-12">
      <h2 class="text-3xl sm:text-4xl font-medium mb-5 font-serif text-gray-800">Contact Us</h2>
      <p class="text-gray-600 mb-8">
        Take a peek at our socials, send us a message, or reach out with your enquiry—we’d love to hear from you!
      </p>
      
      <!-- Icons Section -->
      <div class="flex justify-center space-x-8 mb-8">
        <!-- Instagram -->
        <a href="https://www.instagram.com/loveandletters_stationery" target="_blank" class="text-gray-400 hover:text-pink-600">
          <i class="fab fa-instagram text-3xl"></i>
        </a>
        <!-- Facebook -->
        <a href="https://www.facebook.com/profile.php?id=61558773821929#" target="_blank" class="text-gray-400 hover:text-blue-600">
          <i class="fab fa-facebook text-3xl"></i>
        </a>
        <!-- Email -->
        <a href="mailto:info@loveandletters.uk" class="text-gray-400 hover:text-red-600">
          <i class="fas fa-envelope text-3xl"></i>
        </a>
      </div>

      <!-- Enquiry Form Button -->
        <a
          href="https://form.jotform.com/243653030424043"
          target="_blank"
          class="bg-pink-900 text-white px-6 py-3 rounded-lg text-lg font-medium hover:bg-pink-700 transition inline-block">
          Submit an Enquiry
        </a>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ContactUs',
  
}


</script>

<style scoped>
.contact-section {
  background-color: #f9f9f9;
}

.social-links i {
  transition: color 0.3s ease;
}

.social-links a:hover i {
  color: #1d4ed8; /* Adjust hover color */
}
</style>
